import { useEffect } from 'react'
import * as React from 'react'
import { PageContext } from 'types'

const isBrowser = typeof window !== 'undefined'
const DynamicPage = ({ pageContext: { components, title, global_data, three } }: PageContext) => {
  const body = isBrowser ? document.body : null
  const loader = isBrowser ? document.getElementById('preloader') : null
  useEffect(() => {
    setTimeout(() => {
      loader?.classList.add('preloader-hide')
      setTimeout(() => {
        body?.classList.remove('preloader_active')
        body?.classList.add('preloader_ready')
      }, 0)
    }, 0)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {components.map(({ type, type_id, data }, index) => {
        let Component
        try {
          Component = require(`@components/${type}/${type_id}`).default
        } catch (e) {
          return null
        }
        return (
          <Component
            {...data}
            three={three}
            titlePage={title}
            key={`${type}-${type_id}-${index}`}
            {...{ global_data }}
          />
        )
      })}
    </>
  )
}

export default DynamicPage

export { Head } from './Head'
